// src/api/fscCloudContext.js

const FSC_CLOUD_STORAGE_KEY = 'fsc_cloud';

const VALID_FSC_CLOUDS = new Set(['azure', 'gcp', 'aws']);

/** 正規化 FSC 雲端參數（azure | gcp | aws） */
export function normalizeFscCloud(value) {
  if (value == null) return null;
  const s = String(value).trim().toLowerCase();
  if (VALID_FSC_CLOUDS.has(s)) return s;
  if (s.includes('gcp') || s.includes('google')) return 'gcp';
  if (s.includes('aws') || s.includes('amazon')) return 'aws';
  if (s.includes('azure')) return 'azure';
  return null;
}

export function getFscCloudContext() {
  return normalizeFscCloud(localStorage.getItem(FSC_CLOUD_STORAGE_KEY));
}

export function setFscCloudContext(cloud) {
  const normalized = normalizeFscCloud(cloud);
  if (normalized) {
    localStorage.setItem(FSC_CLOUD_STORAGE_KEY, normalized);
  }
  return normalized;
}

/** 合併 project_uuid 與 cloud（params / body 共用） */
export function withFscContext(payload = {}) {
  const next = { ...payload };

  let cloud = normalizeFscCloud(next.cloud ?? next.cloud_provider ?? next.platform);
  if (!cloud) {
    cloud = getFscCloudContext();
  }
  if (cloud) {
    next.cloud = cloud;
  }

  return next;
}
